export default __webpack_public_path__ + "media/images/icons_fc/clock-aae225245399c0ac381ec38574405cd1.png";